<template>
  <label :class="$style.radio" :for="radioId">
    <input
      :id="radioId"
      type="radio"
      :name="radioName"
      :disabled="disabled"
      :checked="checked"
      @click="$emit('update:modelValue', !checked)"
      @blur="$emit('blur', $event)"
      @keydown.enter="event => $emit('enter', event)"
    >
    <lv-icon
      :size="24"
      :name="checked ? 'radio-checked-version2-24' : 'radio-unchecked-version2-24'"
      fill
      :class="$style.radioIcon"
      aria-hidden="true"
    />
    <div :class="$style.radioLabel">
      <span v-if="$slots.label?.()?.[0]?.children?.length">
        <slot name="label" />
      </span>
      <span v-else-if="label" v-text="label" />
    </div>
  </label>
</template>

<script>
  import { LvIcon } from '~~/common/components/loginet-vue-shop/index';
  import awListenersMixin from '~~/common/mixins/awListenersMixin.js';

  export default {
    name: 'AwRadioChooser',
    components: {
      LvIcon,
    },
    mixins: [awListenersMixin],
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
      label: {
        type: String,
        default: '',
      },
      value: {
        type: [Boolean, String, Number],
        default: '',
        required: true,
      },
      radioGroupUuid: {
        type: String,
        required: true,
      },
      inputId: {
        type: [String, Number],
        required: true,
      },
    },
    emits: [
      'blur',
      'enter',
      'radio-mouseup',
      'update:modelValue',
    ],
    computed: {
      radioId () {
        return `radio-${this.radioGroupUuid}-|-${this.inputId}`;
      },
      radioName () {
        return `radio-${this.radioGroupUuid}`;
      },
      checked () {
        const radioInputValue = this.value.toString();
        return radioInputValue && `radio-${this.radioGroupUuid}-|-${radioInputValue}` === this.radioId;
      },
    },
  };
</script>

<style module lang="scss" rel="stylesheet/scss">
.radio {
  display: grid;
  grid-template-columns: min-content auto;
  gap: 8px;
  align-items: center;
  cursor: pointer;

  &Label {
    font-family: $secondary-font;
    font-size: 14px;
    font-weight: $font-weight-normal-v2;
    line-height: 14px;
    color: $color-text-primary;
  }

  &Icon {
    width: 24px;
    height: 24px;
  }

  input {
    appearance: none;
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0.01;
  }

  input:focus-visible + * + .radioLabel {
    text-decoration: underline;
  }

}
</style>
